/**
 * @author QiuYuJia
 * @version 1.0.0
 * @Time 2019-11-22
 */
export default {
  /**
   * 获取 Cookie
   * @param {String} name 要获取的 Cookie 名
   * @return {String} 获取到的 Cookie 值
   */
  getCookie: function(name) {
    var cookieList = document.cookie.split("; ");
    var cookieJson = {};
    for (var index in cookieList) {
      cookieJson[cookieList[index].split("=")[0]] = cookieList[index].split(
        "="
      )[1];
    }
    return cookieJson[name];
  },

  /**
   * 格式化时间
   * @param {String} fmt 格式
   * @param {Object} date 待格式时间对象
   * @return {String} 格式化后的时间字符串
   */
  dateFormat: function(fmt, date) {
    var ret;
    const opt = {
      "y+": date.getFullYear().toString(), // 年
      "M+": (date.getMonth() + 1).toString(), // 月
      "d+": date.getDate().toString(), // 日
      "h+": date.getHours().toString(), // 时
      "m+": date.getMinutes().toString(), // 分
      "s+": date.getSeconds().toString() // 秒
    };
    for (var k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(
          ret[1],
          ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
        );
      }
    }
    return fmt;
  },

  /**
   * 生成一个UUID
   * @return {String} 一个新的 UUID
   */
  uuid: function() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (
      S4() +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      S4() +
      S4()
    );
  },

  /**
   * 获取 Url 参数
   * @param {String} variable 待获取参数名
   * @return {String} 获取到的参数值
   */
  getQueryVariable: function(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  },

  /**
   * 验证邮箱
   * @param {String} mail 待验证邮箱
   * @return {Boolean} true.格式正确 false.格式错误
   */
  validateMail: function(mail) {
    var strRegex = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    if (strRegex.test(mail)) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 验证手机号码
   * @param {String} phone 待验证号码
   * @return {Boolean} true.格式正确 false.格式错误
   */
  validatePhone: function(phone) {
    var phoneReg = /^1[3-578]\d{9}$/;
    if (phoneReg.test(phone)) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 验证用户名
   * @param {String} account 待验证用户名
   * @return {Boolean} true.格式正确 false.格式错误
   */
  validateAccount: function(account) {
    var accountReg = /^[^\u4e00-\u9fa5]{0,}$/;
    if (accountReg.test(account)) {
      return true;
    } else {
      return false;
    }
  }
};
